import { publicApi } from "utils/util";

export const getCartItems = async () => {
  try {
    const { data } = await publicApi.get("/market/cart/items");
    return data.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const addCartItems = async (
  items: { product_id: string; variant_id: string; quantity: number }[],
) => {
  const { data } = await publicApi.post("/market/cart/items", { items });
  return data.data;
};
